// extracted by mini-css-extract-plugin
export default {"cls1":"AxxKwcSkdJR4Ar8KoobG","cls2":"cNZgVkZJBYeVAFhxwbOb AxxKwcSkdJR4Ar8KoobG"};